import React from 'react'
import ProfileImage from '../assets/images/profile.svg'
import HomeImage from '../assets/images/home.svg'
import AboutUsImage from '../assets/images/about-us.svg'
import {useSelector,useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {
    Button, Popover,
    PopoverArrow, PopoverBody,
    PopoverContent,
    PopoverTrigger
} from "@chakra-ui/react";
import {logout} from "../store/userSlice";
function Navbar() {
    const {user} = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    return (
        <div className="d-flex flex-row justify-content-between">
            <div className="d-flex align-items-center profile-options">
                <Popover>
                    <PopoverTrigger>
                        <Button variant="ghost">
                            <img src={ProfileImage} alt={'پروفایل'} className="navbar-image"/>
                        </Button>
                    </PopoverTrigger>
                    <PopoverContent ms={3}>
                        <PopoverArrow/>
                        <PopoverBody>
                            <div className="btn-group-vertical col-12" role="group" aria-label="Vertical button group">
                                <button type="button" className="btn" onClick={() => {
                                    navigate('/Profile')
                                }}>ویرایش پروفایل
                                </button>
                                <hr className='d-block mx-auto'/>
                                <button type="button" className="btn" onClick={() => {
                                    dispatch(logout())
                                }}>خروج
                                </button>
                            </div>
                        </PopoverBody>
                    </PopoverContent>
                </Popover>

                <div className="mb-auto">
                    <h3 className="mt-3 mb-2">{user.name}</h3>
                    <h6 className="my-0">خوش آمدید!</h6>
                </div>
            </div>
            <div className={"d-flex flex-row"}>
                <img src={AboutUsImage} alt={'درباره ما'} className="navbar-image" style={{cursor: 'pointer'}}
                     onClick={() => navigate('/AboutUs')}/>
                <img src={HomeImage} alt={'خانه'} className="navbar-image" style={{cursor: 'pointer'}}
                     onClick={() => navigate('/')}/>
            </div>
        </div>
    );
}

export default Navbar;
